import type { FormImageTileProps } from '../types';
import type { FieldValues } from 'react-hook-form';

import { FormFieldShell } from '../FormFieldShell';

import { ImageTile } from './ImageTile';

export const FormImageTile = <TFieldValues extends FieldValues = FieldValues>(
  props: FormImageTileProps<TFieldValues>,
) => {
  const {
    name,
    label,
    description,
    hint,
    isRequired,
    url,
    isRemovable = false,
    className,
  } = props;
  return (
    <FormFieldShell
      name={name}
      description={description}
      render={({ field, fieldState, fieldId }) => (
        <ImageTile
          id={fieldId}
          label={label}
          hint={hint}
          isRequired={isRequired}
          isInvalid={fieldState.invalid}
          url={url}
          isRemovable={isRemovable}
          className={className}
          onChange={field.onChange}
        />
      )}
    />
  );
};
